
  <div class="board-column column-container">
    <div class="board-column-header d-flex align-items-center mb-2 position-relative drag-handle" >
    <!-- Column Title -->
    <div class="fs-xsm text-dark fw-bold flex-grow-1 text-truncate">
      {{ localTitle }}
    </div>

    <!-- Three-dot menu button -->
    <div class="dropdown">
      <i
        class="bi bi-three-dots dropdown-toggle"
        type="button"
        id="columnMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
      </i>
      <ul class="dropdown-menu dropdown-menu-end rounded-3 p-0 text-xxs border-0 shadow-sm" aria-labelledby="columnMenuButton">
        <li><a class="dropdown-item" href="#" @click.prevent="enableEditing"><i class="bi bi-pencil"></i> Rename</a></li>
        <li v-if="!bucket.tasks || bucket.tasks.length === 0">
    <a class="dropdown-item " href="#" @click.prevent="deleteColumn"><i class="bi bi-trash3"></i> Delete</a>
  </li>
      </ul>
    </div>

    <!-- Inline edit input (appears when renaming) -->
    <input
      v-if="isEditing"
      ref="titleInput"
      v-model="localTitle"
      @keydown.enter="handleTitleSubmit"
      @blur="handleTitleSubmit"
      class="form-control form-control-sm position-absolute "
      type="text"
    />
  </div>
        <button class="btn btn-sm fs-xsm btn-light board-add-task-btn w-100 mx-0 text-decoration-none text-start mt-2 small"  @click="startAddingTask(bucket.id)">
        <i class="bi bi-plus-lg fw-bold me-1"></i> Add task
        </button>
        <div
            v-if="isAddingTask && selected_column_id === bucket.id"
            class="mt-2 column-add-task-active"
            v-click-outside="cancelAddingTask"
          >
            <AddTaskCard
              :column_id="selected_column_id"
              @add-task="finishAddingTask"

            />
          </div>

    <div class="mt-2 column-scrollable" ref="columnRef" @scroll="handleScroll">
      <draggable
        v-model="bucket.tasks"
        group="tasks"
        item-key="id"
        class="task-list-dropzone d-flex flex-column gap-2"
        :empty-insert-threshold="120"
        :delay="200"
        :delay-on-touch-only="true"
        :touch-start-threshold="10"
        @change="on_drag_change"
      >
      
        <template #item="{ element }">
          
          <div v-if="element">
          <Card :task="element"
          :bucket="bucket"
          :buckets="buckets"
          :statuses="statuses"
          :priorities="priorities"
          @open-task-modal="open_task_modal(element, bucket)"
          @task-deleted="remove_task"
          @task-updated="handleTaskUpdated"
          :members="members"
          />
          </div>
        </template>
      </draggable>

      <!-- Loader only if more pages exist -->
    <div
      v-if="loading_column_page && bucket.tasks_pagination.current_page < bucket.tasks_pagination.total_pages"
      class="text-center my-2"
    >
      <div class="spinner-border text-secondary spinner-border-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>


    </div>
  </div>

<teleport to="body">

 <div class="modal fade" :id="`task_modal_${bucket.id}`" tabindex="-1"  ref="taskModal">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content bg-white p-4">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn-close fs-10" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-header">
     <h5 class="modal-title w-100" id="task_modalLabel">

  <!-- Truncated span -->
  <span
    v-if="!editingTaskName"
    @click="editingTaskName = true"
    ref="taskSpan"
    class="cursor-pointer text-truncate d-block w-100 overflow-hidden py-1"
  >
    {{ selected_task?.name }}
  </span>

  <!-- Editable div -->
  <textarea
  v-else
  ref="taskInput"
  class="task-input w-100 form-control bg-light rounded-5 border-1"
  v-model="task_name"
  @blur="editingTaskName = false; update_task('name', task_name)"
  @input="autoResize()"
></textarea>


</h5>

    </div>
      <div class="modal-body">

        <!-- Assignee -->
        <div class="mb-3 p-3 border rounded-3 bg-light task-assignees-panel">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="task-field-label mb-0">Assignees</label>

            <div ref="modalAssignContainer" class="dropdown">
              <button
                type="button"
                class="border-0 rounded-circle d-inline-flex align-items-center justify-content-center task-assignee-add-btn"
                @click.stop.prevent="toggle_modal_assign_dropdown"
                title="Add assignee"
              >
                <i class="bi bi-person-plus-fill"></i>
              </button>

              <div
                ref="modalAssignDropdown"
                class="dropdown-menu shadow border-0 dropdown-assign"
                :class="{ show: show_modal_assign_dropdown }"
                data-bs-auto-close="outside"
                @click.stop
              >
                <input
                  type="text"
                  class="form-control form-control-sm text-xxs rounded-3 border-0 border-bottom mb-2"
                  placeholder="Type a name or email address"
                  v-model="modal_assign_search_query"
                />

                <div v-if="modal_filtered_assignees.length > 0">
                  <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Assigned</div>
                  <div
                    v-for="assignee in modal_filtered_assignees"
                    :key="assignee.id"
                    class="dropdown-item d-flex align-items-center gap-2 rounded-3 overflow-hidden task-assignee-menu-item"
                  >
                    <div class="rounded-circle text-white d-inline-flex align-items-center justify-content-center fw-bold task-assignee-menu-avatar">
                      {{ getInitials(assignee?.portal_access?.base_profile_details?.creater?.first_name) }}{{ getInitials(assignee?.portal_access?.base_profile_details?.creater?.last_name) }}
                    </div>
                    <span class="flex-grow-1 text-truncate text-dark fw-500 task-assignee-menu-name">{{ assignee?.portal_access?.base_profile_details?.creater?.full_name || 'Unnamed assignee' }}</span>
                    <button
                      type="button"
                      class="border-0 rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0 task-assignee-menu-remove"
                      title="Remove assignee"
                      @click.stop.prevent="remove_assigned_user_from_modal(assignee)"
                    >
                      <i class="bi bi-x"></i>
                    </button>
                  </div>
                </div>

                <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Suggestions</div>
                <div
                  v-for="member in modal_filtered_suggestions"
                  :key="member.id"
                  class="dropdown-item d-flex align-items-center gap-2 rounded-3 overflow-hidden task-assignee-menu-item"
                  @click.stop.prevent="assign_user_from_modal(member.id)"
                >
                  <div class="rounded-circle text-white d-inline-flex align-items-center justify-content-center fw-bold task-assignee-menu-avatar">
                    {{ getInitials(member.full_name) }}
                  </div>
                  <span class="flex-grow-1 text-truncate text-dark fw-500 task-assignee-menu-name">{{ member.full_name }}</span>
                </div>
                <div v-if="modal_filtered_suggestions.length === 0" class="text-muted small px-2 py-1 fs-xsm">
                  No matches
                </div>
              </div>
            </div>
          </div>

          <div v-if="(selected_task?.assignees || []).length > 0">
            <div class="d-flex flex-wrap gap-2 task-assignee-list">
              <div
                v-for="assignee in selected_task?.assignees || []"
                :key="assignee.id"
                class="d-inline-flex align-items-center gap-2 bg-white rounded-pill border shadow-sm task-assignee-chip"
                :title="assignee?.portal_access?.base_profile_details?.creater?.full_name"
              >
                <span class="rounded-circle text-white d-inline-flex align-items-center justify-content-center fw-bold task-assignee-avatar">
                  {{ getInitials(assignee?.portal_access?.base_profile_details?.creater?.first_name) }}{{ getInitials(assignee?.portal_access?.base_profile_details?.creater?.last_name) }}
                </span>
                <span class="text-truncate text-dark fw-500 task-assignee-name">
                  {{ assignee?.portal_access?.base_profile_details?.creater?.full_name || 'Unnamed assignee' }}
                </span>
                <button
                  type="button"
                  class="border-0 rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0 task-assignee-remove"
                  title="Remove assignee"
                  @click.stop.prevent="remove_assigned_user_from_modal(assignee)"
                >
                  <i class="bi bi-x"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-else class="d-flex align-items-center gap-2 bg-white rounded-3 px-2 py-2 task-assignee-empty">
            <i class="bi bi-person"></i>
            <span>No assignees yet</span>
          </div>
        </div>

 <div class="row mb-3">
 <!-- Progress -->
  <div class="col-md-6">
    <label class="task-field-label">Progress</label>
    <div class="dropdown task-status-dropdown">
      <button
        ref="progressDropdownToggle"
        type="button"
        class="border rounded-3 bg-light d-flex align-items-center w-100 overflow-hidden task-control-shell task-status-dropdown-toggle"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
        @click="open_task_status_dropdown('status')"
      >
        <span class="border-0 bg-transparent text-success d-inline-flex align-items-center justify-content-center task-control-icon">
          <i class="bi bi-circle-fill"></i>
        </span>
        <span class="flex-grow-1 text-start text-xxs text-truncate">
          {{ selected_task_status_label('status') || task_status_placeholder('status') }}
        </span>
        <span
          v-if="local_task_status_id"
          class="task-status-clear d-inline-flex align-items-center justify-content-center text-secondary"
          role="button"
          title="Clear progress"
          aria-label="Clear progress"
          @click.stop="clear_task_status('status')"
        >
          <i class="bi bi-x"></i>
        </span>
        <i class="bi bi-chevron-down text-secondary me-2"></i>
      </button>
      <div class="dropdown-menu w-100 p-2 border-0 shadow-sm task-status-dropdown-menu">
        <input
          ref="progressSearchInput"
          v-model="task_status_search_status"
          type="text"
          class="form-control form-control-sm text-xxs mb-2"
          placeholder="Search progress..."
        />
        <button
          type="button"
          class="dropdown-item text-xxs rounded-2"
          @click="select_task_status('status', '')"
        >
          No progress
        </button>
        <button
          v-for="status in filtered_task_status_options('status')"
          :key="status.id"
          type="button"
          class="dropdown-item text-xxs rounded-2 d-flex align-items-center justify-content-between"
          @click="select_task_status('status', status.id)"
        >
          <span>{{ format_label(task_status_option_name('status', status)) }}</span>
          <i v-if="is_task_status_selected('status', status.id)" class="bi bi-check2 text-primary"></i>
        </button>
        <div v-if="can_add_task_status('status')" class="border-top mt-1 pt-1">
          <button
            type="button"
            class="dropdown-item text-xxs rounded-2 text-primary fw-500"
            @click="start_task_status_add('status')"
          >
            <i class="bi bi-plus-lg me-1"></i> Add "{{ task_status_search_status.trim() }}"
          </button>
        </div>
      </div>
    </div>
    <small v-if="task_status_add_error && adding_task_status_field === 'status'" class="text-danger">
      {{ task_status_add_error }}
    </small>
  </div>

  <!-- Priority -->
  <div class="col-md-6">
    <label class="task-field-label">Priority</label>
    <div class="dropdown task-status-dropdown">
      <button
        ref="priorityDropdownToggle"
        type="button"
        class="border rounded-3 bg-light d-flex align-items-center w-100 overflow-hidden task-control-shell task-priority-control task-status-dropdown-toggle"
        :data-priority-tone="priority_tone(selected_priority)"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
        @click="open_task_status_dropdown('priority')"
      >
        <span class="border-0 bg-transparent d-inline-flex align-items-center justify-content-center task-control-icon">
          <i class="bi bi-flag-fill"></i>
        </span>
        <span class="flex-grow-1 text-start text-xxs text-truncate">
          {{ selected_task_status_label('priority') || task_status_placeholder('priority') }}
        </span>
        <span
          v-if="local_priority_status_id"
          class="task-status-clear d-inline-flex align-items-center justify-content-center text-secondary"
          role="button"
          title="Clear priority"
          aria-label="Clear priority"
          @click.stop="clear_task_status('priority')"
        >
          <i class="bi bi-x"></i>
        </span>
        <i class="bi bi-chevron-down text-secondary me-2"></i>
      </button>
      <div class="dropdown-menu w-100 p-2 border-0 shadow-sm task-status-dropdown-menu">
        <input
          ref="prioritySearchInput"
          v-model="task_status_search_priority"
          type="text"
          class="form-control form-control-sm text-xxs mb-2"
          placeholder="Search priority..."
        />
        <button
          type="button"
          class="dropdown-item text-xxs rounded-2"
          @click="select_task_status('priority', '')"
        >
          No priority
        </button>
        <button
          v-for="status in filtered_task_status_options('priority')"
          :key="status.id"
          type="button"
          class="dropdown-item text-xxs rounded-2"
          @click="select_task_status('priority', status.id)"
        >
          {{ format_label(task_status_option_name('priority', status)) }}
        </button>
        <div v-if="can_add_task_status('priority')" class="border-top mt-1 pt-1">
          <button
            type="button"
            class="dropdown-item text-xxs rounded-2 text-primary fw-500"
            @click="start_task_status_add('priority')"
          >
            <i class="bi bi-plus-lg me-1"></i> Add "{{ task_status_search_priority.trim() }}"
          </button>
        </div>
      </div>
    </div>
    <small v-if="task_status_add_error && adding_task_status_field === 'priority'" class="text-danger">
      {{ task_status_add_error }}
    </small>
  </div>
</div>


<!-- Dates -->
<div class="row mb-3">

  <!-- Start Date -->
  <div class="col-md-6">
    <label class="task-field-label">Start Date</label>

    <div class="input-group input-group-sm border rounded-3 bg-light task-date-control">

      <span class="input-group-text border-0 bg-transparent text-secondary d-inline-flex align-items-center justify-content-center">
        <i class="bi bi-calendar"></i>
      </span>

      <input
        type="date"
        class="form-control text-xxs border-0 bg-transparent shadow-none"
        v-model="local_start_date"
        @change="update_task('start_date', local_start_date)"
      >

      <!-- Clear -->
      <button
        v-if="local_start_date"
        type="button"
        class="btn border-0 bg-transparent text-danger"
        @click="clear_start_date"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>
  </div>


  <!-- Due Date -->
  <div class="col-md-6">
    <label class="task-field-label">Due Date</label>

    <div class="input-group input-group-sm border rounded-3 bg-light task-date-control">

      <span class="input-group-text border-0 bg-transparent text-secondary d-inline-flex align-items-center justify-content-center">
        <i class="bi bi-calendar-check"></i>
      </span>

      <input
        type="date"
        class="form-control text-xxs border-0 bg-transparent shadow-none"
        v-model="local_due_date"
        @change="update_task('due_date', local_due_date)"
      >

      <!-- Clear -->
      <button
        v-if="local_due_date"
        class="btn border-0 bg-transparent text-danger"
        @click="clear_due_date"
      >
        <i class="bi bi-x"></i>
      </button>

    </div>
  </div>

</div>

        <!-- Notes -->
           <div class="mb-3">
          <label class="form-label text-xxs mt-2">Notes</label>
          <textarea
            id="task-notes"
            class="form-control form-control-sm text-xxs rounded-3 border-0 shadow-sm bg-light"
            rows="4"
            placeholder="Type a description or add notes here"
            v-model="description"
            @blur="update_task('description', description)"
            @input="auto_grow($event)"
          ></textarea>
           </div>

        <!-- Checklist -->
      <div class="mb-3" id="checklist-container">
    <label class="form-label text-xxs fw-500">Checklist</label>


    <div
      v-for="(item, index) in checklist_with_placeholder"
      :key="item.id || index"
      class="d-flex align-items-center mb-2"
    >
      <!-- Checkbox -->
      <input
      class="form-check-input me-2 small"
      type="checkbox"
      v-model="item.is_completed"
      :disabled="!item.id"
      @change="toggleItem(item)"
    />


      <!-- Text input -->
      <input
      type="text"
      class="form-control form-control-sm border-0 text-xxs flex-grow-1"
      v-model="item.text"
      :placeholder="(!item.id && index === checklist_with_placeholder.length - 1) ? 'Add checklist item...' : ''"
      @keydown.enter.prevent="submit_checklist_item(item)"
      :ref="'checklistInput-' + index"
      :class="{ 'text-decoration-line-through': item.is_completed }"
    />

      <!-- Delete button -->
      <button
        v-if="item.id || item.text.trim()"
        type="button"
        class="btn btn-sm ms-2 px-2 py-1 text-danger"
        @click="delete_check_list_item(item)"
      >
        <i class="bi bi-trash"></i>
      </button>
    </div>
  </div>

     <div class="">
      <div class="d-flex justify-content-between align-items-center">
       <label class="form-label text-xxs mt-2 fw-500">Attachments</label>
       <!-- Attachments -->
         <div class="mt-2">
            <input
              type="file"
              ref="fileInput"
              class="d-none"
              @change="handle_file_change"
            />

            <button
              class="btn btn-primary btn-sm text-xxs mb-2"
              @click="$refs.fileInput.click()"
            >
              Add attachment
            </button>
          </div>
          </div>

         <ul class="list-group list-group-flush text-xxs w-75 border-0 w-100">
          <li
            v-for="file in task_attachments"
            class="list-group-item d-flex align-items-center justify-content-between bg-light border-0 mb-2 shadow-sm rounded-3"
          >
            <div class="d-flex align-items-center">
              <img
                v-if="isImage(file.file_name)"
                :src="file.s3_url"
                alt="preview"
                class="me-2 task-attachment"
              />
              <div class="d-flex flex-column">
                <span class="fw-semibold">{{ file.file_name }}</span>
              </div>
            </div>

            <!-- Actions (3-dot menu placeholder) -->
            <div class="dropdown">
              <button
                class="btn btn-sm"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-three-dots-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a class="dropdown-item" @click.prevent="downloadFile(file)">Download</a>
                </li>
                <li>
                  <a class="dropdown-item text-danger" @click.prevent="delete_task_attachment(file.id)">Delete</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
     </div>




         <div class="mb-3 mt-2">
            <form @submit.prevent="add_comment">
              <label class="form-label text-xxs mt-2 fw-500">Comment</label>
              <textarea
                id="comment"
                class="form-control form-control-sm text-xxs rounded-3 border-0 shadow-sm bg-light"
                rows="3"
                placeholder="Type your message here"
                v-model="comment"
              ></textarea>

              <div class="d-flex justify-content-end mt-2">
                <button class="btn btn-primary btn-sm text-xxs" type="submit">Send Comment</button>
              </div>
           </form>
           </div>

<div v-for="comment in comments" :key="comment.id" class="mt-3">
  <div class="d-flex gap-2 align-items-start">
    <div class="rounded-circle d-flex justify-content-center align-items-center text-xxs text-white bg-primary w-20 h-20 flex-shrink-0 mt-1">
      {{ getInitials(`${comment.creator?.creater?.first_name || ''} ${comment.creator?.creater?.last_name || ''}`) }}
    </div>

    <div class="flex-grow-1">
      <div class="d-flex justify-content-between align-items-start">
        <span class="text-xxs fw-500">
          {{ comment.creator.creater.first_name }} {{ comment.creator.creater.last_name }}
        </span>

        <div class="d-flex align-items-center gap-2">
          <p class="text-xxs mb-0 text-muted">{{ formatTimestamp(comment.created_at, true) }}</p>
          <button
            v-if="String(comment.creator?.creater?.id) === String(get_user_id())"
            @click="delete_comment(comment.id)"
            class="btn btn-sm text-danger border-0 text-xxs p-0"
            title="Delete"
          >
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>

      <p class="text-xxs mb-0 lh-sm">{{ comment?.content }}</p>
    </div>
  </div>
</div>

      </div>
        <small v-if="selected_task?.created_at" class="d-block text-muted text-xxxs fw-normal mb-1 text-end">
        Created {{ formatTimestamp(selected_task.created_at, true) }}
      </small>
    </div>
    
  </div>
</div>
</teleport>
